var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcQuizzes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.518 0a1.53 1.53 0 0 1 0 3.059l-.477-.001v1.26c4.873 1.056 8.528 5.455 8.528 10.721C21.569 21.093 16.74 26 10.784 26S0 21.093 0 15.04C0 9.593 3.907 5.074 9.028 4.222V3.058h-.476a1.53 1.53 0 1 1 0-3.058h4.966Zm-2.734 7.137c-4.294 0-7.774 3.538-7.774 7.902 0 4.364 3.48 7.902 7.774 7.902 4.294 0 7.775-3.538 7.775-7.902 0-4.364-3.48-7.902-7.775-7.902Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.851,
    cy: 15.634,
    rx: 1.505,
    ry: 1.529
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.851 11.556c.277 0 .502.224.502.501v2.566a.502.502 0 0 1-1.003 0v-2.566a.5.5 0 0 1 .501-.501Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuizzes);
export default __webpack_public_path__ + "static/media/ic_quizzes.0c12312cedb423470dd075af75a25230.svg";
export { ForwardRef as ReactComponent };